export default function HardwareAndSchematicsDirective() {
  return {
    template: require('./hardware-and-schematics.html'),
    scope: {
      customerId: '=',
      rmmReportingSource: '=',
      assessmentId: '=',
      serverStatus: '@',
      workstationStatus: '@',
      schematicStatus: '@',
    },
    controller: 'HardwareAndSchematicsController',
    controllerAs: 'hardwareAndSchematicsVM',
    bindToController: true,
    replace: true,
  };
}
